<template>
  <v-container fluid>

    <v-row justify="center">
      <v-col cols="12">
        <h1>アカウント一覧</h1>
      </v-col>
    </v-row>

    <v-row justify="center" v-if="view.errors.length > 0">
      <v-col cols="12">
        <mp-error :errors="view.errors" message-key="message.admin.account.error." />
      </v-col>
    </v-row>

    <v-row justify="space-between">
      <v-col cols="6" md="3" class="py-0">
        <mp-button min wide @click="goAdd">アカウント追加</mp-button>
      </v-col>
      <v-col cols="6" md="3" class="py-0">
        <mp-button min wide @click="downloadCsv">CSVダウンロード</mp-button>
      </v-col>
    </v-row>

    <v-row justify="center">
      <v-col cols="12">
        <h2>検索条件</h2>
      </v-col>
    </v-row>

    <v-row justify="center" dense>
      <v-col cols="6" md="3">
        <mp-label>グループ分類</mp-label>
      </v-col>
      <v-col cols="6" md="3" outlined tile>
        <mp-input-box min>
          <v-select
            v-model="form.groupSmallId"
            :items="view.groupList"
            item-text="text"
            item-value="value"
            label="選択してください"
            id="groupSmallId"
            hide-details
            solo
            dense
            color="green"
            item-color="green"
          ></v-select>
        </mp-input-box>
      </v-col>
      <v-col cols="6" md="3">
        <mp-label>{{ view.keywordLable.ja }}</mp-label>
      </v-col>
      <v-col cols="6" md="3" outlined tile>
        <mp-input-box min>
          <v-text-field
            v-model="form.keyword"
            id="keyword"
            hide-details
            solo
            dense
          ></v-text-field>
        </mp-input-box>
      </v-col>
    </v-row>

    <v-row justify="center" dense>
      <v-col cols="6" md="3">
        <mp-label>氏名</mp-label>
      </v-col>
      <v-col cols="6" md="3" outlined tile>
        <mp-input-box min>
          <v-text-field
            v-model="form.name"
            id="name"
            hide-details
            solo
            dense
          ></v-text-field>
        </mp-input-box>
      </v-col>
      <v-col cols="6" md="3">
        <mp-label>メールアドレス</mp-label>
      </v-col>
      <v-col cols="6" md="3" outlined tile>
        <mp-input-box min>
          <v-text-field
            v-model="form.mailAddress"
            id="mailAddress"
            hide-details
            solo
            dense
          ></v-text-field>
        </mp-input-box>
      </v-col>
    </v-row>

    <v-row justify="end">
      <v-col cols="6" md="2" class="py-1">
        <mp-button min wide @click="goSearch">検索</mp-button>
      </v-col>
    </v-row>

    <template v-if="search.show">
      <v-row justify="center">
        <v-col cols="12">
          <h2>検索結果</h2>
        </v-col>
      </v-row>
    </template>

    <template v-if="search.show && search.list.length > 0">
      <v-row justify="center">
        <v-col cols="12" class="pt-0">
          <div>
            リンクをクリックすることで詳細を表示できます。
          </div>
        </v-col>
      </v-row>

      <v-row justify="space-between">
        <v-col cols="5" class="py-0">
          <mp-button red min @click="beforePasswordReset">選択行のパスワードをリセット</mp-button>
          <mp-dialog resetList confirm :show="dialog.resetConfirm" @clickOk="goPasswordReset"
                     @clickCancel="dialog.resetConfirm = false"/>
          <mp-dialog resetList :show="dialog.resetComplete" @clickOk="afterPasswordReset" />
          <mp-dialog requireSelect :show="dialog.requireSelect" @clickOk="dialog.requireSelect = false" />
        </v-col>
        <v-col cols="4" class="py-0">
          <div class="text-right ma-0 py-0 list-count">一覧件数：{{ search.list.length | addComma }}件</div>
        </v-col>
      </v-row>

      <v-row justify="center">
        <v-col cols="12">
          <v-data-table
            v-model="form.selected"
            show-select
            item-key="accountId"
            :single-select="false"
            :headers="headers"
            :items="search.list"
            locale="ja-jp"
            loading-text="読込中"
            no-data-text="データがありません。"
            height="400"
            fixed-header
            hide-default-footer
            mobile-breakpoint=0
            class="elevation-1"
            :page.sync="search.paging.page"
            :items-per-page="search.paging.itemsPerPage"
            @page-count="search.paging.pageCount = $event"
          >
            <template v-slot:item="{ item, isSelected, select }">
                <tr :class="stopRowClass(item)">
                  <td><v-simple-checkbox :value="isSelected" @input="select($event)" :ripple="false" ></v-simple-checkbox></td>
                  <td>{{ item.mailAddress }}</td>
                  <td><router-link :to="'/admin/account/detail/' + item.accountId">{{ item.name }}</router-link></td>
                  <td>{{ item.groupLargeNameJp }}＞{{ item.groupSmallNameJp }}</td>
                  <td>{{ item.companyName }}<br>{{ item.branchName !== null ? item.branchName : '' }}</td>
                  <td>{{ item.loginDt | dateFormatter }}</td>
                  <td align="center">{{ item.groupAdminFlg === "1" ? '○' : ''}}</td>
                  <td align="center">{{ item.tempStopFlg === "1" ? '○' : ''}}</td>
                  <td align="center">{{ item.adminFlg === "1" ? '○' : ''}}</td>
                </tr>
            </template>
          </v-data-table>
          <div class="text-center pt-2">
            <v-pagination color="#0F9956" circle v-model="search.paging.page"
                          :length="search.paging.pageCount"></v-pagination>
          </div>
        </v-col>
      </v-row>

    </template>
    <template v-else-if="search.show && search.list.length === 0">

      <v-row justify="center">
        <v-col cols="12" class="pt-0">
          <div>
            検索条件に該当するアカウントは、ありません。
          </div>
        </v-col>
      </v-row>
    </template>

  </v-container>
</template>

<script>
import MpLabel from '@/components/item/MpLabel.vue'
import MpInputBox from '@/components/item/MpInputBox.vue'
import MpButton from '@/components/item/MpButton.vue'
import MpDialog from '@/components/item/MpDialog.vue'
import { Common, AdminAccount } from '@/api'
import MpError from '@/components/item/MpError.vue'

export default {
  name: 'AdminAccountList',
  components: {
    MpError,
    MpLabel,
    MpInputBox,
    MpButton,
    MpDialog
  },
  data: () => ({
    view: {
      errors: [],
      groupList: [],
      keywordLable: {
        ja: ''
      },
      csvCompanyLabel: {
        ja: ''
      },
      csvBranchLabel: {
        ja: ''
      }
    },
    form: {
      groupSmallId: null,
      keyword: '',
      name: '',
      mailAddress: '',
      selected: []
    },
    search: {
      show: false,
      list: [],
      paging: {
        page: 1,
        pageCount: 5,
        itemsPerPage: 50
      }
    },
    headers: [],
    dialog: {
      resetConfirm: false,
      resetComplete: false,
      requireSelect: false
    }
  }),
  computed: {
  },
  methods: {
    stopRowClass (item) {
      return item.tempStopFlg === '1' ? '_stop' : ''
    },
    getGroupList () {
      return this.view.groupList
    },
    async goSearch () {
      this.view.errors = []
      this.form.selected = []
      this.search.list = await AdminAccount.search(this.form)
      await this.$store.dispatch('formAdminAccountList', this.form)
      // 検索結果表示
      this.search.show = true
    },
    goAdd () {
      // アカウント追加画面へ遷移
      this.$router.push({ path: '/admin/account/add' })
    },
    beforePasswordReset () {
      if (this.form.selected.length > 0) {
        // リセット確認ダイアログを表示
        this.dialog.resetConfirm = true
      } else {
        // 未選択エラーダイアログを表示
        this.dialog.requireSelect = true
      }
    },
    async goPasswordReset () {
      this.view.errors = []
      // リセット確認ダイアログ非表示
      this.dialog.resetConfirm = false

      await AdminAccount.passwordReset({ accountIdList: this.form.selected.map(account => account.accountId) })
        .then(() => { this.dialog.resetComplete = true })
        .catch(error => {
          this.view.errors = error.messages
        })
    },
    afterPasswordReset () {
      // ダイアログを閉じる
      this.dialog.resetComplete = false

      this.goSearch()
    },
    restResult () {
      this.form = this.$store.state.form.adminAccountList
      this.goSearch()
    },
    async downloadCsv () {
      if (window.navigator.msSaveBlob) {
        alert('IE以外のブラウザで実行してください。')
        return
      }

      const downloadUrl = await AdminAccount.download()

      // aタグでダウンロード
      const link = document.createElement('a')
      link.href = downloadUrl
      link.click()
    },
    async setLabel () {
      const list = await Common.labelList({ key: 'account' })
      this.view.keywordLable.ja = this.getValueFromLabelList(list, 'label.account.keyword.ja')
      this.view.csvCompanyLabel.ja = this.getValueFromLabelList(list, 'label.account.csv.company.ja')
      this.view.csvBranchLabel.ja = this.getValueFromLabelList(list, 'label.account.csv.branch.ja')
    },
    getValueFromLabelList (list, key) {
      const ele = list.find(ele => ele.configKey === key)
      if (ele === undefined || ele.configVal === undefined) {
        return ''
      } else {
        return ele.configVal
      }
    },
    setHeaders () {
      this.headers = [
        { text: 'ID', value: 'mailAddress', sortable: false },
        { text: '氏名', value: 'name', sortable: false, width: 200 },
        { text: '所属', value: 'groupName', sortable: false, width: 220 },
        { text: this.view.keywordLable.ja, value: 'companyName', sortable: false, width: 200 },
        { text: '最終ログイン日時', value: 'loginDt', sortable: false, width: 150 },
        { text: '責任者', align: 'center', value: 'groupAdminFlg', sortable: false, width: 80 },
        { text: '一時停止', align: 'center', value: 'tempStopFlg', sortable: false, width: 105 },
        { text: '管理者', align: 'center', value: 'adminFlg', sortable: false, width: 80 }
      ]
    }
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      // 詳細画面からの遷移時は、元の検索結果を表示させる。
      if (from.name === 'AdminAccountDetail') {
        vm.restResult()
      }
    })
  },
  created: async function () {
    await this.setLabel()
    this.setHeaders()
    this.view.groupList = (await Common.groupList())
      .flatMap(groupLarge => groupLarge.groupSmallList
        .map(groupSmall => ({
          text: groupLarge.groupLargeName.ja + '＞' + groupSmall.groupSmallName.ja,
          value: groupSmall.groupSmallId
        })))
    this.view.groupList.unshift({ text: '----', value: '' })
  }
}
</script>

<style scoped>
  .v-data-table td {
    width: 50px;
  }
  ._stop {
    background-color: #c6c6c6;
  }
</style>
